module.exports = __webpack_public_path__ + "static/img/zonghePad.71bbf89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/zonghePad.png
// module id = nOKG
// module chunks = 1